<template>
  <el-dialog :draggable="true" title="设置" :visible.sync="dialogVisible" width="30%" append-to-body :close-on-click-modal="false" >
    <div class="sd-flex" style="height: 200px">
      <div class="operator-list box-panel">
        <div v-for="op in operateList_" :key="op" class="operator-item" @click="handleOperatorClick(op)">
          {{ op }}
        </div>
      </div>
      <div class="field-list box-panel">
        <div v-for="field in fields_" :key="field.name" class="text-nowrap field-row" @click="handleOperatorClick(field.name)"> 
          <span class="field-alias">{{ field.alias }}</span>
          <span class="field-name">{{ field.name }}</span>
        </div>
      </div>
      
    </div>
     <div class="result-sql">
      <div style="margin-bottom: 10px">设置查询条件：</div>
      <el-input ref="input" type="textarea" :rows="5" placeholder="" v-model="settingSql_" :spellcheck ="false"></el-input>
    </div>
    <template #footer>
        <span class="dialog-footer">
          <el-button @click="close">关闭</el-button>
            <el-button @click="handleClearSql">清空</el-button>
            <el-button type="primary" @click="handleConfirm">
                确定
            </el-button>
        </span>
    </template>
  </el-dialog>
</template>

<script>
export default {
name: 'SqlConstructionDialog',

data() {
  return {
    dialogVisible:false,
    settingSql_:"",
    operateList_:[],
    fields_:[]
  };
},
created(){
  this.operateList_=["=","<>","LIKE",">",">=","AND","<","<=","OR","%","()","NOT","IN",'IS','NULL']
},

mounted() {
  
},

methods: {
  handleConfirm(){
    this.$emit('confirm',this.settingSql_)
    this.close()
  },
  handleOperatorClick(op){
    this.settingSql_ +=` ${op} `  
    this.$refs.input.focus()
  },
  handleClearSql(){
    this.settingSql_=''
  },
  open(sql,fields){
    this.fields_=fields ||[]
    this.settingSql_=sql?sql:''
    this.dialogVisible = true
  },
  close(){
    this.dialogVisible = false
  }
},
};
</script>

<style scoped>
.result-sql{
margin: 15px 0 0 0;
}
.box-panel{
border-radius: 4px;
margin-right: 10px;
height:calc(100% - 20px)
}
.field-list{
flex:1;
overflow-y: auto;
padding-top: 3px;
border: 1px solid #DCDFE6;
}
.operator-list{
flex:0 200px;
display: flex;
flex-direction: row;
flex-wrap: wrap;

}
.operator-item{
width: 45px;
height: 20px;
text-align: center;
border: 1px solid #DCDFE6;
border-radius: 4px;
padding: 3px;
margin-left: 10px;
margin-top: 10px;
cursor: pointer;
transition: border 0.3s;
}
.operator-item:hover{
border: 1px solid #409eff;
}
.field-row{
padding: 2px 10px;
font-size: 12px;
color: gray;
transition: padding 0.1s;
}
.field-row:hover{
padding-left: 5px;
background-color: #f5f7fa;
}
.field-alias{
margin-right:10px;
font-size: 15px;
color: black;
}
</style>